import { Info } from 'lucide-react'

// Until the cutover the sheet's syncs own places and producers, so the CMS
// shows them read-only and says why.
export function CatalogNotice({ catalogEditing }: { catalogEditing: boolean }) {
  if (catalogEditing) return null
  return (
    <div className="notice" role="note">
      <Info size={18} />
      <span>Por enquanto, lugares e perfis vêm da planilha. A edição aqui começa na virada para o Guve 2.0.</span>
    </div>
  )
}
